import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoreLocalData, getUserData } from "../../utils/localStorage";
import { getGarmentInspectionByCustomer, getQrCodeForImage } from "../../services/QrCode/postQrCodeByStatus";
import {
  deleteGarmentInspectionImage,
  getGarmentInspectionImages,
  uploadLogo,
} from "../../services/GarmentInspection/GarmentInspection";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import { Alert } from "react-bootstrap";
import { BRAND_BASE_URL, STORE_BASE_URL } from "../../services/BaseURL";
import ImageView from "./ImageView";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { errorMessage, successMessage } from "../../utils/alertMessage";

const GarmentQrCodeListAdmin = () => {
  const location = useLocation();
  const {
    mobileNumber,
    customerFirstName,
    customerLastName,
    bookingOrderId,
    storeCustomerId,
    invoiceNo,
    orderNo,
    storeId
  } = location.state || {}; // Fallback to prevent undefined errors

  let firstName = customerFirstName === null ? "" : customerFirstName
  let lastName = customerLastName === null ? "" : customerLastName

  const { brandProfileData, userProfileData } =
    getUserData();

    let userRole = userProfileData;

    const { storeLocalData } = getStoreLocalData();
      const countryCode = storeLocalData?.countryCode;


  const navigate = useNavigate();
  const [tagInfo, setTagInfo] = useState([]);
  const [tokenDataValue, setTokenDataValue] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(false);
  const [viewImage, setViewImage] = useState(false);
  const [viewImageData, setViewImageData] = useState("");

  const fetchQrCode = () => {
    const data = {
      status: [
        "BOOKED",
        "IN_PROCESS",
        "PROCESSED",
        "DELIVERED",
        "DONE",
        "CANCEL",
        "UNPROCESSED",
        "OUT_FOR_DELIVERY",
        "DELAY_STATUS",
        "IN_WAREHOUSE",
      ],
    };

    let qrCodeData = [];
    let inspectionImagesData = {};

    // postQrCodeByStatus(storeCustomerId, storeId, bookingOrderId, data)
    getQrCodeForImage(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          qrCodeData = response.data.map((item) => ({
            ...item,
            checked: false,
          }));
          if (qrCodeData) {
            getGarmentInspectionImages(bookingOrderId)
              .then((response) => {
                if (!response.data.error) {
                  inspectionImagesData = response.data.map;
                  const combinedData = qrCodeData.map((item) => ({
                    ...item,
                    inspectionImages: inspectionImagesData[item.id] || [],
                  }));
                  setTagInfo(combinedData);
                }
              })
              .catch((err) => {
                console.error("Error fetching inspection images:", err);
              });
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching QR code data:", err);
      });
  };

  const getTokenData = async () => {
    //   const token = await getAccessToken();
    const token = "";
    setTokenDataValue(token);
  };
  useEffect(() => {
    fetchQrCode();
    getTokenData();
  }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermView, setSearchTermView] = useState(false);

  const filterUserList = () => {
    return tagInfo.filter((item) => {
      const qrcode = item.qrcode?.toLowerCase();
      const garmentAlias = item.garmentAlias?.toLowerCase();
      const garment = item.garment?.toLowerCase();
      const category = item.category?.toLowerCase();
      const matchesSearchTermQrcode = qrcode?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermGarmentAlias = garmentAlias?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermGarment = garment?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermCategory = category?.includes(
        searchTerm.toLowerCase()
      );
      return (
        matchesSearchTermGarmentAlias ||
        matchesSearchTermGarment ||
        matchesSearchTermQrcode ||
        matchesSearchTermCategory
      );
    });
  };

  const filteredData = filterUserList();

  const deleteImage = (itemId, imageId) => {
    deleteGarmentInspectionImage(itemId, imageId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          fetchQrCode();
        }
      })
      .catch((err) => {
        console.error("Error fetching inspection images:", err);
      });
  };

  const handleGarmentLogoUpload = (event, itemId, qrcode) => {
    const fileInput = event.target;
    const imageFile = fileInput.files[0];

    if (!imageFile) {
        console.error("No file selected");
        return;
    }

    // Generate a custom name for the image
    const date = new Date();
    const customFileName = `${qrcode}-${itemId}-${Math.floor(date.getSeconds() / 2)}.jpg`;

    // Create a new file object with the custom name
    const renamedImageFile = new File([imageFile], customFileName, { type: imageFile.type });

    uploadLogo(itemId, renamedImageFile)
        .then((response) => {
            if(response.status === 200 ) {
                setModalVisible(true);
                setApiResStatus(true);
            } else {
                setModalVisible(true);
                setApiResStatus(false);
            }
            fetchQrCode();
        })
        .catch((error) => {
            console.error("Upload failed", error);
            setModalVisible(true);
            setApiResStatus(false);
        });
};
  const shareMessage = (item) => {
    const billNo = invoiceNo;
    const customerName = firstName + " " + lastName;
    const garmentName =
      item.garmentAlias !== "" ? item.garmentAlias : item.garment;
    const garmentService = item.addOnList
      .map((addOnItem) => addOnItem.serviceName)
      .join(", ");
    const sharableLinks = item.inspectionImages
      ? item.inspectionImages.map((img) => img.sharableLink).filter(Boolean) // Get valid URLs
      : [];

    const body = `Bill No: ${billNo}\nCustomer Name: ${customerName}\nMobile No.: ${mobileNumber}\nGarment: ${garmentName.replace(
      /_/g,
      " "
    )}\nService: ${garmentService}\nTag: ${
      item.qrcode
    }\nInspection Images:\n${sharableLinks.join("\n\n")}`;

    const mobile = mobileNumber;
    // Remove any non-numeric characters and check if the number starts with a '+'
    let formattedMobile = mobile.replace(/[^\d+]/g, '');  // Remove non-numeric and non-plus characters

    if (!formattedMobile.startsWith('+')) {
      formattedMobile = `${countryCode}${formattedMobile}`;  // Add country code only if not already present
    }
    if (!formattedMobile) {
      return alert("Mobile number is invalid");
    }

    let url = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      body
    )}&phone=${formattedMobile}`;

    window.open(url, '_blank');
  };
  const shareAllMessage = () => {
    const billNo = invoiceNo;
    const customerName = `${firstName} ${lastName}`;


    // Collect all garment names, services, QR codes, and images
    const garmentDetails = filteredData.map(item => {
      const garmentName =
        item.garmentAlias !== '' ? item.garmentAlias : item.garment;
      const garmentService = item.addOnList
        .map(addOnItem => addOnItem.serviceName)
        .join(', ');
      const sharableLinks = item.inspectionImages
        ? item.inspectionImages.map(img => img.sharableLink).filter(Boolean)
        : [];


      return {
        garment: garmentName.replace(/_/g, ' '),
        service: garmentService,
        qrcode: item.qrcode,
        images: sharableLinks,
      };
    });


    // Construct the message body
    let body = `Bill No: ${billNo}\nCustomer Name: ${customerName}\nMobile No.: ${mobileNumber}\n\n`;


    garmentDetails.forEach((detail, index) => {
      if (detail.images.length > 0) {
      body += `Garment ${index + 1}: ${detail.garment}\nService: ${
        detail.service
      }\nTag: ${detail.qrcode}\n`;
        body += `Inspection Images:\n${detail.images.join('\n')}\n\n`;
      }
    });


    const mobile = mobileNumber;
    let formattedMobile = mobile.replace(/[^\d+]/g, '');  // Remove non-numeric and non-plus characters

    if (!formattedMobile.startsWith('+')) {
      formattedMobile = `${countryCode}${formattedMobile}`;  // Add country code only if not already present
    }
    if (!formattedMobile) {
      return alert("Mobile number is invalid");
    }


    let url = `whatsapp://send?text=${encodeURIComponent(
      body,
    )}&phone=${formattedMobile}`;


    window.open(url, '_blank');
  };


  const fetchGarmentInspectionByCustomer = (tagId) => {
    
    getGarmentInspectionByCustomer(tagId)
      .then((response) => {
        if (!response.data.error) {
          if(response.state === false) {
            errorMessage(response.data.message)
          } else if(response.data.notification.notified === false) {
            const mobile = mobileNumber;
            let formattedMobile = mobile.replace(/[^\d+]/g, '');  // Remove non-numeric and non-plus characters

            if (!formattedMobile.startsWith('+')) {
              formattedMobile = `${countryCode}${formattedMobile}`;  // Add country code only if not already present
            }
            if (!formattedMobile) {
              return alert("Mobile number is invalid");
            }

              let url = `whatsapp://send?text=${encodeURIComponent(
                response?.data?.notification.notification
              )}&phone=${formattedMobile}`;
              window.open(url, '_blank');
          } else if(response.data.notification.notified) {
            successMessage("Message Sent Successfully")
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching QR code data:", err);
      });
  };



  const renderTagInfoItem = () => {
    return filteredData?.map((item, index) => {
      const garmentName =
        item.garmentAlias !== "" ? item.garmentAlias : item.garment;

      const displayImages = item.inspectionImages || [];

      // Create 4 items per row (add blank spaces if less than 4 images)
      const imageRows = [];
      for (let i = 0; i < 4; i++) {
        imageRows.push(displayImages[i] || { imageCode: null }); // Add null to represent missing images
      }

      return (
        <div>
          <div className="flex flex-1 flex-column">
            <div className="flex flex-1 justify-content-between align-items-center">
              <div className="mx-4 my-2">
                <p className="text-xl font-medium">
                  {item.qrcode} - {garmentName.replace(/_/g, " ")}
                </p>
              </div>
              {displayImages.length > 0 && (
                <div onClick={() => 
                // shareMessage(item)
                fetchGarmentInspectionByCustomer(item.id)
                } 
                className="mx-4 my-1 cursor-pointer">
                  <i
                    className="pi pi-whatsapp"
                    style={{
                      fontSize: "25px",
                      marginRight: 30,
                      color: "green",
                    }}
                  ></i>
                </div>
              )}
            </div>
            <div className="flex  " style={{ backgroundColor: "#F6FAFF" }}>
              <div className="flex flex-1 justify-content-between align-items-center my-2 mx-4">
                {/* Display up to 4 images in a row */}
                {imageRows.map((image, index) => (
                  <div
                    className="m-2"
                    key={index}
                    style={{
                      flex: 1,
                      borderRadius: 5,
                      borderWidth: 1,
                      borderColor: "#C1C9D3",
                      borderStyle: "dashed",
                      position:"relative"
                    }}
                  >
                    {image.imageCode && (
                      <div className="cursor-pointer"
                        style={{ position: "absolute", top: -12, right: -5 }}
                      >
                        <div onClick={() => deleteImage(item.id, image.id)}>
                          <i
                            className="pi pi-times-circle"
                            style={{
                              fontSize: "25px",
                              marginRight: 30,
                              color: "red",
                            }}
                          ></i>
                        </div>
                      </div>
                    )}
                    <div className="m-2">
                      {image.imageCode ? (
                        <div className="flex justify-content-center align-items-center cursor-pointer"
                          onClick={() => {
                            setViewImage(true);
                            setViewImageData(image);
                          }}
                        >
                          <img
                            // src={image.tagImageUrl}
                            src={BRAND_BASE_URL + "/store/api/external/v1/order-tag-image-by-code/" + image.imageCode}
                            style={{
                              width: 100,
                              height: 100,
                            }}
                          />
                        </div>
                      ) : (
                        <div
                         className="flex justify-content-center align-items-center cursor-pointer"
                        >
                          <div>
                            <div>
                              <label
                                htmlFor={`file-upload-${item.id}`}
                                className="custom-file-upload"
                              >
                                <i className="pi pi-upload"></i> Choose Garment Image
                              </label>
                              <input
                                 id={`file-upload-${item.id}`} 
                                type="file"
                                onChange={(e) => handleGarmentLogoUpload(e, item.id, item.qrcode)}
                                style={{ display: "none" }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => 
                  { userRole === "BY_STORE" ? 
                    navigate("/OrdersGarmentInfo", {
                      state: {
                        bookingOrderId: bookingOrderId,
                        storeCustomerId: storeCustomerId,
                        },
                        }) : navigate(-1)} 
                        }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Garment Inspection
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => shareAllMessage()}
          >
            <i
                    className="pi pi-whatsapp"
                    style={{
                      fontSize: "25px",
                      marginRight: 30,
                      color: "#fff",
                    }}
                  ></i>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setSearchTermView(!searchTermView)}
          >
            <i
              className="pi pi-search"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: "#fff" }}>
        {searchTermView && (
            <div className="flex-1 mx-4 mt-4 mb-2">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder="Search QrCode"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>
        )}
        <div>
          {tagInfo.length > 0 ? (
            <div>{renderTagInfoItem()}</div>
          ) : (
            <p
              className="text-xl font-medium text-center my-4"
              style={{
                color: "#008EFF",
              }}
            >
              No Garment Present
            </p>
          )}
        </div>
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={apiResStatus === true ? "success" : false}
          text={
            apiResStatus === true
              ? "Garment Image Upload Successfully"
              : "Please try again later"
          }
        />
        <ImageView
            setViewImage={setViewImage}
            viewImage={viewImage}
            viewImageData={viewImageData}
            mobileNumber={mobileNumber}
            customerFirstName={firstName}
            customerLastName={lastName}
            invoiceNo={invoiceNo}
            orderNo={orderNo}
          />
      </div>
      <div style={{
        // position: 'absolute',
        bottom: 20,
        left: 10,
        right: 10,
        alignItems: 'center',
        backgroundColor: '#fff',
        paddingVertical: 8,
      }}>
        <p className="text-xl font-medium text-center my-4" style={{ color: 'red' }} >Once the order is delivered, all garment photo will be automatically deleted.</p>
      </div>
    </div>
  );
};

export default GarmentQrCodeListAdmin;
